import  React, {use, useEffect, useState} from 'react';

import "./styles/estandar/FormStyle.css";
import "./styles/estandar/ButtonStyles.css";
import "./styles/Login.css";

import loadingIcon from '../assets/img/loadico.png';
import backUpi from '../assets/img/upiic.jpg';
import axios from "axios";
import Cookies from 'js-cookie';

import { MdError } from "react-icons/md";

import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { useConfig } from '../contexts/ConfigContext';
//A
const Login = () =>{
    const [loadingScreen, setLoadingScreen] = useState(false);
    const [mainMensaje, setMainMensaje] = useState("Inicia sesión");
    const [mostrarInputPass, setMostrarInputPass] = useState(false);
    const navigate = useNavigate();
    const config = useConfig();


    const[correo, setCorreo] = useState("");
    const[pass, setPass] = useState("");

    const [mensajeError, setMensajeError] = useState("Este es un error de prueba");
    const [showMsgError, setShowMsgError] = useState(false);
    
    
    const handleSiguenteBtn = async() =>{
        //e.preventDefault();
        setMainMensaje("Introduce tu contraseña");
        setMostrarInputPass(true);
    }

    const setearErrores = (jsonErrores)=>{
          for (const field in jsonErrores) {
          if (jsonErrores.hasOwnProperty(field)) {
            const errorMessage = jsonErrores[field][0]; // Toma el primer mensaje de error

            // Aquí necesitarías un mapeo o una convención de nombres
            // para saber a qué `set` de estado llamar.
            switch (field) {
              case 'correo':
                alert(errorMessage);
                break;
              case 'contrasena':
                alert(errorMessage);
                break;
              default:
                console.warn(`Error para campo desconocido: ${field}`);
            }
            }
        }
    }
    
    const handleIniciarSesion = async() =>{

        //e.preventDefault();

        setLoadingScreen(true);
       

        const peticionJSON = {
            correo: correo,
            contrasena: pass
        }

        const API_URL = `${config.API_URL}/api/usuario/iniciar`;
        setTimeout( async() => {

        try{

            const response = await axios.post(API_URL, peticionJSON, {
                headers:{
                     'Content-Type': 'application/json'
                }
            });

            if(response.status == 200){
                const turid = response.data.turid;
                console.log("Inicio de sesion exitosos");
                //Cookies.set('usr', response.data.token, {expires: 1});      
                //Cookies.set('turid',turid, {expires: 1});
                Cookies.set('usr', response.data.token, { expires: 1, path: '/', sameSite: 'Lax', secure: false });      
                Cookies.set('turid', turid, { expires: 1, path: '/', sameSite: 'Lax', secure: false });
                
                if(turid === "rid1"){
                    navigate("/Home");
                }else if(turid === "rid2"){
                    navigate("/Home");
                }else{
                    console.log("Respuesta del servidor invalida");
                }
                
            }
            } catch (error) {
              if(error.status === 400){
                    
                    setMensajeError("Usuario y/o contraseña incorrectos");
                    setMainMensaje("Inicia sesión");
                    setShowMsgError(true);
                   // Espera 5000ms = 5 segundos
              }else if(error.status == 500){
                     setMensajeError("500: Error interno del servidor");
                     setMainMensaje("Inicia sesión");
                    setShowMsgError(true);
              }else{
                    console.log(error);
                    setMensajeError("No se ha podido establecer conexión con el servidor");
                    setMainMensaje("Inicia sesión");
                    setShowMsgError(true);
              }
            
        }  }, 1000);

    


    }

    const handleNuevoIntento = () => {
        setLoadingScreen(false);
        setMostrarInputPass(false);
        setCorreo('');
        setPass('');
        setShowMsgError(false);
        setMensajeError('');
    }


    return(
        <div className='L-mainBody'>
            <img className={loadingScreen?"loginMainimgF":"loginMainimg"} src={backUpi}/>
            <div className='loginFormdiv'>
                <div className={loadingScreen?'LoginBarLoadingDeploy':'LoginBarLoading'}>
                    {!showMsgError &&<img className={loadingScreen?'imgLoadingLogin':'hiden'} src={loadingIcon}/>}
                    {showMsgError &&  <div className='msgErrorLogin'>
                        <MdError size="90px"/>
                        <h3>{mensajeError}</h3>
                        <form onSubmit={(e)=>{e.preventDefault(); handleNuevoIntento()}}><button className='buttonStandart' type='submit'>Aceptar</button></form>
                        
                    </div>}
                   
                </div>
                <div className={loadingScreen?'hiden':'formLoginContainer'}>
                    <h1 className='loginMensajePrincipal'>{mainMensaje}</h1>
                    <form className={mostrarInputPass ? 'hiden' : 'divCorreo'} onSubmit={(e) => {e.preventDefault();  handleSiguenteBtn();}}>
                        <label htmlFor='correo'>Correo:</label>
                        <input className="inputF" type='text' name='correo' value={correo} onChange={(e) => setCorreo(e.target.value)} required />
                        <button className='buttonStandartR' type="submit">Siguiente</button>
                    </form>

                    
                    <form className={mostrarInputPass?'divContra':'hiden'} onSubmit={(e)=>{e.preventDefault(); handleIniciarSesion();}}>
                        <label>Contraseña:</label>
                        <input className='inputF' type='password' value={pass} onChange={(e) => setPass(e.target.value)}/>
                        <button className='buttonStandartR' type='submit'>Inicia sesi&oacute;n</button>
                    </form>
            

                </div>
            </div>
        </div>
    );
}

export default Login;